module.exports = __webpack_public_path__ + "img/gradient-add.e7b87541.svg";